import { createClient } from '@supabase/supabase-js';

// Using the provided active Supabase project credentials
const SUPABASE_URL = 'https://uaalszxyfjodxpelzhcy.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVhYWxzenh5ZmpvZHhwZWx6aGN5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM3NTYxMTIsImV4cCI6MjA4OTMzMjExMn0.3x-CH2gYHOeynhdKoAnTsuM8KhCEV-57TkDW-iNbtmg';

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase variables');
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
});

export default supabase;